import { clarity } from 'react-microsoft-clarity';

export function initClarity(): void {
  const clarityId = process.env.REACT_APP_CLARITY_ID;

  if (clarityId) {
    clarity.init(clarityId);
    console.info('[Clarity] Inicializado');
  } else {
    console.info('[Clarity] Não inicializado - Variável de ambiente ausente');
  }
}
